import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5ce8726"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-wrapper" }

import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import {BarController, BarElement, CategoryScale, Chart, LinearScale, Tooltip} from "chart.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageViewBarChart',
  props: {
    labels: {},
    values: {},
    label: {}
  },
  setup(__props: any) {

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip);

// eslint-disable-next-line no-undef
const props = __props;

const canvas = ref<HTMLCanvasElement>();
let chart: Chart | undefined;

function renderChart() {
  if (!canvas.value)
    return;

  chart?.destroy();
  chart = new Chart(canvas.value, {
    type: "bar",
    data: {
      labels: props.labels,
      datasets: [{
        label: props.label,
        data: props.values,
        backgroundColor: "#009DE2"
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {legend: {display: false}},
      scales: {y: {beginAtZero: true, ticks: {precision: 0}}}
    }
  });
}

onMounted(renderChart);
watch(() => [props.labels, props.values], renderChart, {deep: true});
onBeforeUnmount(() => chart?.destroy());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "canvas",
      ref: canvas
    }, null, 512)
  ]))
}
}

})